/**
 * Add endpoints of specific api calls in this file
 * 
 * for example : 
 *      {endpoint: "api/public/do_something", method: "POST", args: ["param1", "param2"] },
 * 
 * will be available in controllers as :
 *      this.api.public.do_something(param1, param2, function(err){...})
 */

module.exports = [
    {endpoint: "api/pdf/gen", method: "POST", sendMethod: "post", dataEncoding: "multipart", args: [
        "filename", 
        "html", 
    ] },
    {endpoint: "api/xls/genDevices", method: "POST", sendMethod: "post", dataEncoding: "multipart", args: [
        "filename", 
        "devices", 
    ] },
] ;